module.exports = __webpack_public_path__ + "img/members-solid-icon.6ef80751.svg";